/*
 *  -----------------------------------------------------------------------
 *    <copyright file="loading.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import cn from 'clsx';
import React from 'react';
import './loading.scss';

interface ILoadingParams {
    float?: boolean;
    overlay?: boolean;
    inside?: boolean;
    absolute?: boolean;
}

const Loading = ({ float, overlay, inside, absolute }: ILoadingParams) => (
    <div
        className={cn(
            { 'loading-float': float },
            { loading: !float },
            { 'loading-overlay': overlay },
            { 'loading-inside': inside },
            { 'loading-absolute': absolute },
        )}
    >
        <div className="loader" data-testid="loader" />
    </div>
);

export default Loading;
